import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAiSparkle(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7.518 7.518Q6.5 8.536 6.5 10q0-1.464-1.018-2.482T3 6.5q1.464 0 2.482-1.018T6.5 3q0 1.464 1.018 2.482T10 6.5q-1.464 0-2.482 1.018"
        fill="currentColor"
      />
      <path
        d="M15.327 15.327Q13 17.655 13 21q0-3.345-2.327-5.673T5 13q3.345 0 5.673-2.327T13 5q0 3.345 2.327 5.673T21 13q-3.345 0-5.673 2.327"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
